var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4669 40.1833C14.4669 43.8777 11.4591 46.8635 7.73751 46.8635C4.01615 46.8635 1.0083 43.8777 1.0083 40.1833C1.0083 36.4888 4.01615 33.503 7.73751 33.503H14.4669V40.1833Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8328 40.1833C17.8328 36.4888 20.8404 33.503 24.562 33.503C28.2835 33.503 31.2912 36.4888 31.2912 40.1833V56.8839C31.2912 60.5784 28.2835 63.5644 24.562 63.5644C20.8404 63.5644 17.8328 60.5784 17.8328 56.8839V40.1833Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5618 13.3606C20.8403 13.3606 17.8326 10.3747 17.8326 6.68031C17.8326 2.9859 20.8403 0 24.5618 0C28.2832 0 31.2911 2.9859 31.2911 6.68031V13.3606H24.5618Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5628 16.7515C28.2842 16.7515 31.2921 19.7374 31.2921 23.4319C31.2921 27.1262 28.2842 30.1122 24.5628 30.1122H7.68875C3.9672 30.1122 0.959351 27.1262 0.959351 23.4319C0.959351 19.7374 3.9672 16.7515 7.68875 16.7515H24.5628Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5298 23.4319C51.5298 19.7374 54.5376 16.7515 58.2592 16.7515C61.9805 16.7515 64.9884 19.7374 64.9884 23.4319C64.9884 27.1262 61.9805 30.1122 58.2592 30.1122H51.5298V23.4319Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1667 23.4316C48.1667 27.1261 45.159 30.1119 41.4375 30.1119C37.7159 30.1119 34.7083 27.1261 34.7083 23.4316V6.68031C34.7083 2.9859 37.7159 0 41.4375 0C45.159 0 48.1667 2.9859 48.1667 6.68031V23.4316Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4338 50.2042C45.1552 50.2042 48.163 53.1899 48.163 56.8844C48.163 60.5789 45.1552 63.5647 41.4338 63.5647C37.7123 63.5647 34.7046 60.5789 34.7046 56.8844V50.2042H41.4338Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4372 46.8635C37.7156 46.8635 34.7078 43.8777 34.7078 40.1833C34.7078 36.4888 37.7156 33.503 41.4372 33.503H58.3111C62.0326 33.503 65.0405 36.4888 65.0405 40.1833C65.0405 43.8777 62.0326 46.8635 58.3111 46.8635H41.4372Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackButton);
export default __webpack_public_path__ + "static/media/slack-button.e501fd40ed6d8e17bc08cc507ba2f759.svg";
export { ForwardRef as ReactComponent };